export default class ImageAd {
  imageSrc: string
  href: string | null

  constructor(imageSrc: string, href: string | null) {
    this.imageSrc = imageSrc
    this.href = href
  }
}
